import { render, staticRenderFns } from "./ourservice-btn.vue?vue&type=template&id=66b451e8&scoped=true&"
import script from "./ourservice-btn.vue?vue&type=script&lang=js&"
export * from "./ourservice-btn.vue?vue&type=script&lang=js&"
import style0 from "./ourservice-btn.vue?vue&type=style&index=0&id=66b451e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b451e8",
  null
  
)

export default component.exports